<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="vl-toolbar">
          <input class="vl-input" type="search" placeholder="Cari nama role&hellip;"
                 aria-label="Cari role" [value]="isKeyword"
                 (input)="onKeywordInput($event.target.value)" (keyup.enter)="applyFilter()">
          <div class="vl-spacer"></div>
          <button type="button" class="vl-btn-primary" (click)="onShowAdd()"
                  data-bs-toggle="modal" data-bs-target="#formData">+ Tambah Role</button>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="vl-card">
              <div class="vl-loading" *ngIf="isTableLoading">
                <img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data">
              </div>
              <div class="vl-scroll">
              <table class="vl-table">
                <thead>
                <tr>
                  <th class="vl-num">No</th>
                  <th>Nama Role</th>
                  <th>Akses Menu</th>
                  <th class="text-right">Aksi</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let v of isData; let i = index" class="vl-row" [class.vl-alt]="i % 2 == 1">
                  <th class="vl-num">{{rowNo(i)}}</th>
                  <td><span class="vl-name" [innerHTML]="highlight(v.name)"></span></td>
                  <td class="vl-muted">{{formatNumber(permissionCount(v))}} dari {{formatNumber(dataPermissions.length)}} menu</td>
                  <td>
                    <div class="vl-actions">
                      <button type="button" class="vl-icon" title="Edit" (click)="onEdit(v)" data-bs-toggle="modal"
                              data-bs-target="#formData"><i class="fa fa-edit"></i></button>
                      <button type="button" class="vl-icon danger" title="Hapus" (click)="onDelete(v)"><i class="fa fa-trash"></i></button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="!isData.length">
                  <td colspan="4" class="vl-empty">Tidak ada data</td>
                </tr>
                </tbody>
              </table><!--end /table-->
              </div>
              <div class="vl-foot">
                <span class="vl-summary">Menampilkan <b>{{formatNumber(summaryFrom())}}&ndash;{{formatNumber(summaryTo())}}</b> dari <b>{{formatNumber(isTotalAll)}}</b> role</span>
                <div class="vl-spacer"></div>
                <nav class="vl-pager" aria-label="Navigasi halaman">
                  <button type="button" class="vl-page" [disabled]="isPage == 1" (click)="goToPage(isPage - 1)">&lsaquo;</button>
                  <ng-container *ngFor="let p of isPages">
                    <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                    <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == isPage"
                            (click)="goToPage(p)">{{p}}</button>
                  </ng-container>
                  <button type="button" class="vl-page" [disabled]="isPage == totalPages()" (click)="goToPage(isPage + 1)">&rsaquo;</button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- FORM -->
<form [formGroup]="isForm" (ngSubmit)="onSubmit()">
  <div class="modal fade" id="formData" aria-labelledby="formDataLabel" aria-hidden="true" data-keyboard="false"
       data-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header vf-header">
          <div>
            <h6 class="modal-title vf-title" id="formDataLabel">{{isForm.value.id ? 'Edit role' : 'Tambah role'}}</h6>
            <div class="vf-subtitle">{{isForm.value.id ? 'Perbarui nama dan akses menu role ini.' : 'Buat role baru beserta akses menunya.'}}</div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" [disabled]="isLoading"></button>
        </div>
        <div class="modal-body">
          <div class="vf-grid">
            <div class="vf-field full">
              <label class="vf-label">Nama Role <span class="req">*</span></label>
              <input type="text" class="vf-input" [class.invalid]="isInvalid('name')"
                     placeholder="Misal: Editor Konten" formControlName="name">
              <div class="vf-error" *ngIf="isInvalid('name')">Nama role wajib diisi.</div>
            </div>
          </div>
          <div class="vp-perm-wrap">
            <label class="vf-label">Akses Menu</label>
            <div class="vp-perm-group" *ngFor="let g of permissionGroups">
              <div class="vp-perm-head">
                <label class="vp-check">
                  <input type="checkbox" [checked]="isGroupChecked(g)" (change)="toggleGroup(g, $event.target.checked)">
                  <span>{{g.name}}</span>
                </label>
              </div>
              <div class="vp-perm-items">
                <label class="vp-check" *ngFor="let p of g.items">
                  <input type="checkbox" [checked]="isChecked(p.id)" (change)="togglePermission(p.id, $event)">
                  <span>{{p.label}}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer vf-footer">
          <button type="button" class="vl-btn-ghost" data-bs-dismiss="modal" [disabled]="isLoading">Batal</button>
          <button type="submit" class="vl-btn-primary" [disabled]="isLoading">
            <i class="fa fa-spinner fa-spin" *ngIf="isLoading"></i> Simpan</button>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- delete confirmation dialog -->
<div class="hds-overlay" *ngIf="isConfirm" (click)="closeConfirm()">
  <div class="hds-dialog" role="alertdialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="hds-a">
      <span class="hds-ico">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
             stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2m-9 0l1 14h8l1-14"/></svg>
      </span>
      <h3>Hapus role ini?</h3>
      <p>Role yang masih dipakai akun admin tidak bisa dihapus.</p>
      <div class="hds-item">
        <span class="hds-item-text"><b>{{isConfirm.v.name}}</b></span>
      </div>
    </div>
    <div class="hds-foot hds-foot-full">
      <button type="button" class="vl-btn-ghost" [disabled]="isDeleting" (click)="closeConfirm()">Batal</button>
      <button type="button" class="hds-btn-danger" [disabled]="isDeleting" (click)="confirmDelete()">
        <i class="fa fa-spinner fa-spin" *ngIf="isDeleting"></i> Hapus</button>
    </div>
  </div>
</div>
